<template>
    <div>
        <div>
            <report-header
                :title="title"
                :isShowDateRange="true"
                :formatDateRangeTitle="dateRange"
            />

            <b-card id="report-card">
                <div id="report-body" class="w-100">
                    <QTable
                        :columns="formattedColumns"
                        :data="result"
                        hide-bottom
                        :loading="isLoading"
                        :rows-per-page-options="[0]"
                    >
                        <template v-slot:body-cell-invoice="props">
                            <q-td :props="props">
                                <a
                                    :href="
                                        '../apps/billing/invoice/view/' +
                                        props.row.inv_id
                                    "
                                >
                                    {{ props.value }}
                                </a>
                            </q-td>
                        </template>
                        <template v-slot:header-cell="props">
                            <q-th :props="props">
                                <strong>{{ props.col.label }}</strong>
                            </q-th>
                        </template>
                        <template v-slot:bottom-row>
                            <q-tr
                                v-if="
                                    result.length == 0 && !isLoading && !isError
                                "
                            >
                                <q-td colspan="8">No records available</q-td>
                            </q-tr>
                            <q-tr v-else-if="result.length > 0">
                                <q-td></q-td>
                                <q-td></q-td>
                                <q-td></q-td>
                                <q-td></q-td>
                                <q-td
                                    ><strong>{{
                                        _toCurrency(grandTotal)
                                    }}</strong></q-td
                                >
                                <q-td></q-td>
                                <q-td></q-td>
                            </q-tr>
                        </template>
                    </QTable>
                </div>
            </b-card>
        </div>
    </div>
</template>
<script>
import Report from "@/mixins/report";
import ReportService from "@/services/report";
import CREPORT from "@/constants/report";
import { QTable } from "quasar";
export default {
    mixins: [Report],
    components: {
        QTable,
        ReportHeader: () => import("@/components/report/report-header")
    },
    props: {
        data: {
            type: Object,
            default() {
                return {
                    start: this.getStartDate("month"),
                    end: this.getEndDate("day")
                };
            }
        }
    },
    data() {
        return {
            locale: "en-US",
            loaded: false,
            result: [],
            tableHeader: [],
            dateRange: "",
            title: "",
            refresh: 0,
            isLoading: true,
            isError: false
        };
    },
    mounted() {
        let self = this;
        // --- toggle navigation options
        self.data.isShowDateRange = true;
        self.data.datePickerOptionDefault = 1;

        self._getSetting().then(() => {
            self.data.start = self.getStartDate("month");
            self.data.end = self.getEndDate("day");
            self.data.from = self.converToUnix(self.data.start);
            self.data.to = self.converToUnix(self.data.end);
            self.init();
        });

        self.$root.$on("report-filter-date-range:refresh", self.init);
        self.$root.$on("ar-out-of-period-sales:refresh", function () {
            self.refresh = 1;
            self.init();
        });

        window.scrollTo(0, 0);
    },
    beforeDestroy: function () {
        this.data.datePickerOptionDefault = null;
        this.$root.$off("report-filter-date-range:refresh", this.init);
    },
    methods: {
        async init(params) {
            let self = this;
            self.loaded = false;
            self.isLoading = true;
            self.isError = false;
            self.grandTotal = 0;

            if (params) {
                self.data.from = params.from;
                self.data.to = params.to;
                self.refresh = params.refresh;
            }

            self.dateRange = self.getDateRange(self.data.from, self.data.to);

            await ReportService.getReport(CREPORT.TYPE.AR_OUT_OF_PERIOD_SALES, {
                from: self.data.from,
                to: self.data.to,
                refresh: self.refresh
            })
                .then(res => {
                    if (res && res.message && res.message.code === 200) {
                        self.result = res.resource.results;
                        self.tableHeader = res.resource.header;
                        self.title = res.resource.meta.title;
                        self.dynamicPageTitle(self.title);
                        self.dateRange = self.getDateRange(
                            res.resource.meta.fromDate,
                            res.resource.meta.toDate
                        );
                        self.loaded = true;
                        for (let n = 0; n < self.result.length; n++) {
                            self.grandTotal += parseFloat(
                                self.result[n].item_total
                            );
                        }
                        self.isLoading = false;
                    } else {
                        throw new Error("Error: Unable to get the report.");
                    }
                })
                .catch(e => {
                    console.error(e.message);
                    self.isError = true;
                    self._message("Error: Unable to get the report", "danger");
                })
                .finally(() => {
                    self.isLoading = false;
                });
        }
    },
    computed: {
        formattedColumns() {
            return [
                {
                    name: "invoice",
                    label: "Invoice #",
                    field: "invoice",
                    align: "left",
                    style: "white-space: nowrap"
                },
                {
                    name: "invoice_date",
                    label: "Invoice Date",
                    field: "invoice_date",
                    align: "left",
                    style: "white-space: nowrap"
                },
                {
                    name: "item_name",
                    label: "Item Name",
                    field: "item_name",
                    align: "left",
                    style: "white-space: nowrap"
                },
                {
                    name: "item_date",
                    label: "Item Date",
                    field: "item_date",
                    align: "left",
                    style: "white-space: nowrap"
                },
                {
                    name: "item_total",
                    label: "Item Total",
                    align: "left",
                    field: row => row.item_total,
                    format: (val, row) => {
                        return this._toCurrency(row.item_total);
                    },
                    style: "white-space: nowrap"
                },
                {
                    name: "create_by",
                    label: "Create By",
                    field: "create_by",
                    align: "left",
                    style: "white-space: nowrap"
                },
                {
                    name: "create_at",
                    label: "Create At",
                    field: "create_at",
                    align: "left",
                    style: "white-space: nowrap"
                }
            ];
        }
    }
};
</script>
